import flow from 'lodash/flow';
import { commonQuestionState } from '../response/reducer';
import { getServerValidationErrors, validate } from '../validators';
import { reduceValidationResults } from '../validators';


const requiredSticky = isRequired => state => {
  const isValid = isRequired ? state.wasStarted : true;
  const errorMessages = isValid ? null : "Please start the timed question.";
  
  return reduceValidationResults(state, {
    errorMessages,
    isValid
  });
};

const addTimedState = props => state => ({
  ...state,
  wasStarted: false,
  validators: [
    requiredSticky(props.required)
  ],
});

const touchAll = state => ({
  ...state
});

export const begin = state => ({
  ...state,
  wasStarted: true,
});

const reducer = props => (state, action) => {
  if (state === undefined) {
    return flow(
      commonQuestionState(props),
      getServerValidationErrors(props),
      addTimedState(props)
    )({});
  }

  switch (action.type) {
    case 'OPEN':
      return flow(begin)(state);

    case 'SUBMIT':
      return flow(touchAll, validate(action))(state);

    default:
      return state;
  }
};

export default reducer;
